import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getDashboardConfig,
  saveDashboardConfig,
} from "../api/dashboardConfig";
import { DashboardWidget } from "../types/dashboard/DashboardConfig";

const QUERY_KEY = "dashboard-config";

export const useDashboardConfig = (customerId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEY, customerId],
    queryFn: () => getDashboardConfig(customerId!),
    enabled: !!customerId,
  });
};

export const useSaveDashboardConfig = (customerId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (widgets: DashboardWidget[]) =>
      saveDashboardConfig(customerId!, widgets),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY, customerId] });
    },
  });
};
